import get from 'lodash/get';
import isEqual from 'lodash/isEqual';

import {loadsSearchRefresh} from '~/modules/loadsSearch/actions';
import canUseLocalStorage from '~/misc/canUseLocalStorage';
import config, {commonEnvProps} from './config';
import {flat} from '~/misc/metrics/utils';


const observeStore = (store, select, onChange) => {
  let currentState = select(store.getState());

  function handleChange() {
    let nextState = select(store.getState());
    if (nextState !== currentState) {
      const oldState = currentState;
      currentState = nextState;
      setTimeout(() => onChange(currentState, oldState), 0);
    }
  }

  let unsubscribe = store.subscribe(handleChange);
  handleChange();
  return unsubscribe;
};


export default (store) => {
  if (canUseLocalStorage) {
    observeStore(
      store,
      (state) => get(state, 'user.token'),
      (token) => {
        if (!token) {
          localStorage.removeItem('sessionToken');
          return null;
        }

        localStorage.setItem('sessionToken', token);
        return null;
      }
    );
    //TODO: here

    observeStore(
      store,
      (state) => get(state, 'user.isSetAlert'),
      (isSetAlert) => {
        localStorage.setItem('isSetAlert', isSetAlert);
      }
    );

    observeStore(
      store,
      (state) => get(state, 'user.isSetAlertPoped'),
      (isSetAlertPoped) => {
        localStorage.setItem('isSetAlertPoped', isSetAlertPoped);
      }
    );

    observeStore(
      store,
      (state) => get(state, 'loadsSearch.query.equipment'),
      (equipment = []) => localStorage.setItem('equipment', JSON.stringify(equipment))
    );

    observeStore(
      store,
      (state) => get(state, 'loads.premiumToolTipHidden'),
      () => localStorage.setItem('premiumToolTipHidden', 1)
    );
  }

  if (window.Intercom) {
    observeStore(store, (state) => get(state, 'routing.pathname'), () => {
      window.Intercom('update');
    });
  }

  observeStore(
    store,
    (state) => get(state, 'user.id'),
    (id) => {
      if (!id) {
        if (window.Intercom) {
          window.Intercom('shutdown');
          window.Intercom('boot', {
            app_id: config.intercom,
            ...flat(commonEnvProps, '__'),
          });
        }
        return null;
      }

      const user = store.getState().user;
      const userName = [user.firstName, user.lastName].filter(i => i).join(' ');

      if (window.Intercom) {
        window.Intercom('update', {
          name: userName,
          email: user.email,
          created_at: new Date(user.createdAt).getTime() / 1000,
        });
      }
      return null;
    }
  );

  let refresher;
  observeStore(
    store,
    (state) => get(state, 'loadsSearch.queryCompleted'),
    (criteria, oldCriteria) => {
      if (isEqual(criteria, oldCriteria)) {
        return;
      }

      if (refresher) {
        clearInterval(refresher);
      }

      if (!criteria) {
        return;
      }

      refresher = setInterval(() => {
        if (store.getState().loadsSearch.tooManyUpdates) {
          return;
        }
        store.dispatch(loadsSearchRefresh());
      }, config.loadsUpdatingInterval);
    }
  );
};



// WEBPACK FOOTER //
// ./src/observe.js